// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1VPst","author":"Table_author__27xyd","authorImage":"Table_authorImage__12zU4","unreadRow":"Table_unreadRow__2TsZ7"};